<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <div class="m-b-24">
        <el-button type="primary" size="small" @click="send = true" v-if="this.$hasPerm('B002&1')">手动发送</el-button>
        &nbsp;&nbsp;&nbsp;
        <el-dropdown @command="exportAll">
          <el-button plain size="small" v-if="this.$hasPerm('B002&2')">
            导出 <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="exportMail">导出至邮箱</el-dropdown-item>
            <el-dropdown-item command="exportExcel">导出至Excel</el-dropdown-item>
            <el-dropdown-item command="exportProperty" v-if="this.$hasPerm('B008')">导出至日蚀</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        &nbsp;&nbsp;&nbsp;
        <el-dropdown @command="voiceCallResult">
          <el-button plain size="small" v-if="this.$hasPerm('B006')">
            批量更新 <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="caseStatus">更新案件状态</el-dropdown-item>
            <el-dropdown-item command="collectionScheme">更新作业方案</el-dropdown-item>
            <el-dropdown-item command="pauseUrge">暂停作业</el-dropdown-item>
            <el-dropdown-item command="continueUrge">继续作业</el-dropdown-item>
            <el-dropdown-item command="openStrategyGroupModal">更新策略组</el-dropdown-item>
            <el-dropdown-item command="openLableModal">更新本人标签</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        &nbsp;&nbsp;&nbsp;
        <el-dropdown @command="importUpdate">
          <el-button plain size="small" v-if="this.$hasPerm('B007')">
            导入更新 <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="importForm">更新还款及金额</el-dropdown-item>
            <el-dropdown-item command="importContactForm">添加联系人</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-form size="small" label-width="100px">
        <!-- 第一行 -->
        <el-row :gutter="12">
          <el-col :span="6">
            <el-form-item label="案件状态">
              <el-select v-model="cas.status" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in statusList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                  :title="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="案件批次号">
              <!-- <el-select v-model="cas.batchNo" filterable multiple collapse-tags placeholder="请选择" :filter-method = "searchBatchList" style="width: 100%;">
                <el-option
                  v-for="item in batchNoList"
                  :key="item.id"
                  :label="item.companyName.substring(0,6) + '...' + '(' + item.batchNo + ')'"
                  :value="item.id"
                  :title="item.companyName + '(' + item.batchNo + ')'">
                </el-option>
              </el-select> -->
              <batch-selector v-model="cas.batchNo" :batchNo="defaultBatchNo"></batch-selector>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="本人状态">
              <el-select v-model="cas.selfStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in selfStatusList"
                  :key="item.modelCode"
                  :label="item.modelName"
                  :value="item.modelCode"
                  :title="item.modelName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系人状态">
              <el-select v-model="cas.contactStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in contactStatusList"
                  :key="item.modelCode"
                  :label="item.modelName"
                  :value="item.modelCode"
                  :title="item.modelName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第二行 -->
        <el-row v-if="ruleSearchShow" :gutter="12">
          <el-col :span="6">
            <el-form-item label="导入时间">
              <el-date-picker style="width: 100%;"
                v-model="cas.importStartTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker style="width: 100%;"
                v-model="cas.importEndTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="贷款机构">
              <el-select v-model="cas.loanInstitution" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in loanInstitutionList"
                  :key="item"
                  :label="item"
                  :value="item"
                  :title="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="策略组">
              <el-select v-model="cas.strategy" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in strategyList"
                  :key="item.id"
                  :label="item.groupName"
                  :value="item.id"
                  :title="item.groupName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第三行 -->
        <el-row v-if="ruleSearchShow" :gutter="12">
          <el-col :span="6">
            <el-form-item label="最后联系时间">
              <el-date-picker style="width: 100%;"
                v-model="cas.lastAnswerTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker style="width: 100%;"
                v-model="cas.lastAnswerTimeEnd"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="轮次">
              <el-select v-model="cas.replyTimes" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in replyTimesList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :title="item.label">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="标签">
               <!-- <labelname-select :labelName.sync="cas.labelName"></labelname-select> -->
              <el-select v-model="cas.labelName" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in labelNameList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                  :title="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 第四行 -->
        <el-row v-if="ruleSearchShow" :gutter="12">
          <el-col :span="6">
            <el-form-item label="作业停止日">
              <el-date-picker style="width: 100%;"
                v-model="cas.collectionEndDay"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="至">
              <el-date-picker style="width: 100%;"
                v-model="cas.collectionEndDayEnd"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
         <el-col :span="12">
            <el-form-item label="AI评分">
              <el-col :span="4">
                <el-switch
                  v-model="isSelected">
                </el-switch>
              </el-col>
              <el-col :span="16">
                <transition name="component-fade" mode="out-in">
                  <el-slider v-if="isSelected"
                    v-model="difficultyScore"
                    range
                    :min="0"
                    :max="100">
                  </el-slider>
                </transition>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="padding15-tb text right">
        <el-button type="primary" @click="searchBtn(1, true)" size="mini" plain> <i class="fa fa-search"></i> 搜索</el-button>
        <el-button @click="resetBtn" size="mini">重置</el-button>
        <el-button v-if="ruleSearchShow" size="mini" type="text" @click="ruleSearchShow = false">收缩<el-icon class="el-icon-arrow-up"></el-icon></el-button>
        <el-button v-else size="mini" type="text" @click="ruleSearchShow = true">展开<el-icon class="el-icon-arrow-down"></el-icon></el-button>
      </div>
    </div>
    <div class="padding15 bg-content">
       <el-table
        v-loading="loading"
        size="small"
        :data="list"
        :row-style="{cursor: 'pointer'}"
        @row-click="toDetail"
        highlight-current-row>
        <el-table-column
          property="aCaseId"
          label="进件号"
          width="110px"
          sortable>
          <template slot-scope="scope">
            <span :title="scope.row.aCaseId" v-if="scope.row.aCaseId.length <= 10">{{scope.row.aCaseId}}</span>
            <span :title="scope.row.aCaseId" v-else>{{scope.row.aCaseId.substring(0,10) + '...'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="batchNoStr"
          label="批次号"
          width="110px">
          <template slot-scope="scope">
            <span :title="scope.row.batchNoStr" v-if="scope.row.batchNoStr == '' || scope.row.batchNoStr == null">--</span>
            <span :title="scope.row.batchNoStr" v-else-if="scope.row.batchNoStr.length <= 10">{{scope.row.batchNoStr}}</span>
            <span :title="scope.row.batchNoStr" v-else>{{scope.row.batchNoStr.substring(0,10) + '...'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="loanInstitutions"
          label="贷款机构"
          width="80px">
          <template slot-scope="scope">
            <span :title="scope.row.loanInstitutions" v-if="scope.row.loanInstitutions == '' || scope.row.loanInstitutions == null">--</span>
            <span :title="scope.row.loanInstitutions" v-else-if="scope.row.loanInstitutions.length > 4">{{scope.row.loanInstitutions.substring(0,4) + '...'}}</span>
            <span :title="scope.row.loanInstitutions" v-else>{{scope.row.loanInstitutions}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="loanName"
          label="贷款人姓名"
          width="60px">
          <template slot-scope="scope">
            <span v-if="scope.row.loanName == '' || scope.row.loanName == null">--</span>
            <span v-else-if="scope.row.loanName.length > 6">{{scope.row.loanName.substring(0,6) + '...'}}</span>
            <span v-else>{{scope.row.loanName}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="importTime"
          label="导入日期"
          width="100px"
          sortable>
          <template slot-scope="scope">
            <span>{{scope.row.importTime | caseTimeTwo}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="overdueDatas"
          label="逾期天数"
          width="70px"
          sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.overdueDatas">{{scope.row.overdueDatas}}</span>
            <span v-else-if="scope.row.overdueDatas === 0">0</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="delegateAmount"
          label="委托金额"
          width="100px"
          sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.delegateAmount">{{scope.row.delegateAmount | money}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="caseStatus"
          label="案件状态"
           width="80px">
        </el-table-column>
        <el-table-column
          property="contactNum"
          label="联系人数"
          width="55px">
          <template slot-scope="scope">
            <span v-if="scope.row.contactNum">{{scope.row.contactNum}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="replyTimes"
          label="轮次"
          width="50px">
          <template slot-scope="scope">
            <span v-if="scope.row.replyTimes">{{scope.row.replyTimes + '次'}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="difficultyScore"
          label="AI评分"
          width="95px"
          sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.difficultyScore">{{scope.row.difficultyScore}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="groupName"
          label="策略组"
          width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.groupName">{{scope.row.groupName}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="urgeStatus"
          label="作业状态"
          width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.urgeStatus == '1'">作业中</span>
            <span v-if="scope.row.urgeStatus == '-1'">暂停作业</span>
            <span v-if="scope.row.urgeStatus == '2'">作业完成</span>
            <span v-if="scope.row.urgeStatus == '' || scope.row.urgeStatus == null">--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="planDiscount"
          label="最高减免"
          width="60px">
          <template slot-scope="scope">
            <span v-if="scope.row.planDiscount">{{scope.row.planDiscount + '%'}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="deduction"
          label="给予减免金额"
          width="70px">
          <template slot-scope="scope">
            <span v-if="scope.row.deduction">{{scope.row.deduction | money}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="collectionEndDay"
          label="作业停止日"
          sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.collectionEndDay">{{scope.row.collectionEndDay | caseTimeTwo}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="collectSendObjectName"
          label="作业对象"
          width="100px">
          <template slot-scope="scope">
            <span :title="scope.row.collectSendObjectName" v-if="scope.row.collectSendObjectName == '' || scope.row.collectSendObjectName == null">--</span>
            <span :title="scope.row.collectSendObjectName" v-else-if="scope.row.collectSendObjectName.length > 6">{{scope.row.collectSendObjectName.substring(0,6) + '...'}}</span>
            <span :title="scope.row.collectSendObjectName" v-else-if="scope.row.collectSendObjectName.length <= 6">{{scope.row.collectSendObjectName}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="lastAnswerTime"
          label="最新联系时间"
          width="120px"
          sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.lastAnswerTime">{{scope.row.lastAnswerTime | caseTimeOne}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="selfStatus"
          label="本人联系状态"
          width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.selfStatus" :class="`tag ${scope.row.selfColor}`">{{scope.row.selfStatus}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="noSelfStatus"
          label="联系人状态"
          width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.noSelfStatus" :class="`tag ${scope.row.noSelfColor}`">{{scope.row.noSelfStatus}}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
       </el-table>
       <div class="text center margin15-tb">
         <el-pagination
           @size-change="handleSizeChange"
           @current-change="handleCurrentChange"
           :current-page="currentPage"
           :page-sizes="[50, 100, 200]"
           :page-size="pageSize"
           layout="total, sizes, prev, pager, next, jumper"
           :total="recordsFiltered">
         </el-pagination>
       </div>
    </div>
    <div class="dialog">
      <el-dialog
        title="手动发送"
        :visible.sync="send"
        width="35%"
        center>
        <el-form label-width="150px">
          <el-form-item label="发送对象:">
            <el-checkbox-group v-model="cas.target">
              <el-checkbox label="本人">本人</el-checkbox>
              <el-checkbox label="直系">直系</el-checkbox>
              <el-checkbox label="非直系">非直系</el-checkbox>
              <el-checkbox label="失联修复">失联修复</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="发送方式:">
            <el-select v-model="cas.sendType" @change="getChangeType">
              <el-option
                v-for="item in sendType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送通道:">
            <el-select v-model="cas.channel" >
              <el-option
                v-for="item in channelList"
                :key="item.code"
                :label="item.desc"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送模版:">
            <el-select v-model="cas.sendTemplate">
              <el-option
                v-for="item in templateList"
                :key="item.value"
                :label="item.name"
                :value="item.content+'&&'+item.id+'&&'+item.type"
                :title="item.content">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送时间:">
            <el-select v-model="cas.sendTimeWay" @change='getValue'>
              <el-option
                v-for="item in times"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="this.cas.sendTimeWay === 'manual_timing' ">
            <el-form-item label="请选择定时发送时间:">
              <el-date-picker
                v-model="timing"
                type="datetime"
                placeholder="SEND TIME"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 195px;">
              </el-date-picker>
            </el-form-item>
          </div>
          <!-- <el-form-item label="发送比例(%):">
            <el-input v-model="cas.sendMsgRate" @keyup.native="number" style="width:195px;"></el-input>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit" size="small">确认发送</el-button>
        </div>
      </el-dialog>
      <!--批量更新作业方案 -->
      <el-dialog
        title="作业设置"
        :visible.sync="collectionScheme"
        width="40%"
        center>
        <el-form label-width="150px">
          <el-form-item label="作业设置:">
            <el-radio v-model="cas.collectionSetting" label="msg">短信</el-radio>
            <el-radio v-model="cas.collectionSetting" label="v&m">短信+语音</el-radio>
          </el-form-item>
          <el-form-item label="作业天数:">
            <el-input-number v-model="cas.days" controls-position="right" :min="1" :max="30" label="最大为30天"></el-input-number> 天
          </el-form-item>
          <el-form-item label="最高减免:">
            <el-input-number v-model="cas.maxMitigate" controls-position="right" :min="0" :max="100" label="最大为100"></el-input-number> %
          </el-form-item>
          <el-form-item label="作业对象:">
            <el-checkbox-group v-model="cas.CollectionObjects">
              <el-checkbox label="benrendianhua">本人</el-checkbox>
              <el-checkbox label="zhixidianhua">直系</el-checkbox>
              <el-checkbox label="feizhixidianhua">非直系</el-checkbox>
              <el-checkbox label="repair">失联修复</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateCollPlan" size="small">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="批量更新案件状态"
        :visible.sync="caseStatus"
        width="40%"
        center>
        <el-form label-width="160px">
          <el-form-item label="案件状态:">
            <el-select v-model="cas.updateStatus" collapse-tags placeholder="请选择">
                <el-option
                  v-for="item in updateStatusList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateCaseStatus" size="small">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="批量更新策略组"
        :visible.sync="caseGrouds"
        width="40%"
        center>
        <el-form label-width="250px">
          <el-form-item label="策略组:">
            <el-select v-model="cas.group">
              <el-option
                v-for="item in strategyGroup"
                :key="item.id"
                :label="item.groupName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否重置作业起始日:">
            <el-switch
              v-model="cas.isReset">
            </el-switch>&#12288;
            <i class="el-icon-question" title="勾选“重置作业起始日”会以当前日期加上设置的作业天数使用新策略重新作业，如在1号开始作业，设置作业10日，若在5号更新策略时勾选，会以新策略作业至15号。"></i>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateStrategyGroup" size="small">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="批量更新本人标签"
        :visible.sync="caseLabel"
        width="40%"
        center>
        <el-form label-width="160px">
          <el-form-item label="标签:">
            <el-select v-model="cas.updateLabelName">
              <el-option
                v-for="item in updateLabelNameList"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateLable" size="small">确认</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="更新还款及金额"
        :visible.sync="importForm"
        width="40%"
        center>
        <el-form label-width="160px">
          <el-form-item label="文件上传">
            <input type="file" @change="getFile($event)">
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" size="small"><a href="/static/template/importUpdateTemplate.xlsx" download style="color: inherit; text-decoration: none;">模板下载</a></el-button>
          <el-button type="primary" @click="importUpdateUploadData($event)" size="small">提交数据</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="添加联系人"
        :visible.sync="importContactForm"
        width="40%"
        center>
        <el-form label-width="160px">
          <el-form-item label="文件上传">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              multiple
              :limit="1"
              :auto-upload="false"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :on-change="fileChanged">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">请上传模版的Excel</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" size="small"><a href="/static/template/importContactTemplate.xlsx" download style="color: inherit; text-decoration: none;">模板下载</a></el-button>
          <el-button type="primary" @click="addContactInfo" size="small">提交数据</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="导出至日蚀系统"
        :visible.sync="exportCaseToPropertyModel"
        width="50%"
        center>
        <el-form label-width="160px">
          <el-form-item>
            <span>您正在导出{{this.count}}个案件到日蚀系统，请配置以下设置</span>
          </el-form-item>
          <el-form-item label="佣金费率:">
            <el-input v-model="zyt.commissionRateA" style="width:80%"></el-input>
          </el-form-item>
          <el-form-item label="平台服务费:">
            <el-input v-model="zyt.platformRate" style="width:80%"></el-input>
          </el-form-item>
          <el-form-item label="起委时间:">
            <el-date-picker style="width: 80%;"
                v-model="zyt.exportStartTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="结委时间:">
            <el-date-picker style="width: 80%;"
                v-model="zyt.exportEndTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-switch
              v-model="zyt.exportNewBatch">
            </el-switch>&#12288;<span>以新批次导入 (若无勾选则当日导入多次皆视为同一批次)</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="info" @click="exportCaseToPropertyModel = false" size="small">取消</el-button>
          <el-button type="primary" @click="exportCaseToZYT" size="small">确定导出</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Base64 } from 'js-base64';
import { setTimeout } from 'timers';
import BatchSelector from '../../../components/bussiness-select/BatchSelector';
// import LabelnameSelect from '../../../components/bussiness-select/labelName';

export default {
  data() {
    return {
      cas: {
        status: [],
        target: [],
        sendTimeWay: 'immediately',
        sendType: 'msg',
        days: '',
        maxMitigate: '',
        importStartTime: '',
        importEndTime: '',
        lastAnswerTime: '',
        lastAnswerTimeEnd: '',
        collectionEndDay: '',
        collectionEndDayEnd: '',
        labelName: [],
        batchNo: [],
        sendTemplate: '',
        sendMsgRate: '100',
        updateStatus: '',
        collectionSetting: 'msg',
        CollectionObjects: ['benrendianhua'],
        group: '',
        updateLabelName: '',
        loanInstitution: [],
        strategy: [],
        replyTimes: [],
        selfStatus: [],
        contactStatus: [],
        ids: [],
        isReset: false,
        channel: ''
      },
      options: [],
      statusList: [],
      loanInstitutionList: [],
      selfStatusList: [],
      contactStatusList: [],
      strategyList: [],
      templateList: [],
      updateStatusList: [],
      batchNoList: [],
      labelNameList: [],
      replyTimesList: [
        {
          value: 'REPLY_TIMES_ONE',
          label: '0'
        },
        {
          value: 'REPLY_TIMES_TWO',
          label: '1'
        },
        {
          value: 'REPLY_TIMES_THREE',
          label: '2-5'
        },
        {
          value: 'REPLY_TIMES_FOUR',
          label: '6-10'
        },
        {
          value: 'REPLY_TIMES_FIVE',
          label: '>10'
        }
      ],
      sendType: [
        {
          value: 'msg',
          label: '短信'
        },
        {
          value: 'ivr',
          label: '语音'
        }
      ],
      times: [
        {
          value: 'immediately',
          label: '立即发送'
        },
        {
          value: 'manual_timing',
          label: '定时发送'
        }
      ],
      isSelected: false,
      difficultyScore: [25, 75],
      list: [],
      send: false,
      timing: '',
      caseStatus: false,
      collectionScheme: false,
      caseGrouds: false,
      caseLabel: false,
      importForm: false,
      importContactForm: false,
      file: '',
      data: {},
      currentPage: 1,
      recordsFiltered: 1000,
      pageSize: 50,
      t: '',
      strategyGroup: [],
      updateLabelNameList: [],
      fileList: [],
      loading: false,
      ruleSearchShow: false,
      zytServerToken: null,
      exportCaseToPropertyModel: false,
      count: null,
      zyt: {
        commissionRateA: null,
        platformRate: null,
        exportStartTime: null,
        exportEndTime: null,
        exportNewBatch: false
      },
      defaultBatchNo: [],
      channelList: []
    };
  },
  watch: {
    $route() {
      this.fetch();
      this.defaultBatchNo = this.getDefaultBatchNo();
    }
  },
  // 进入页面调用此方法
  mounted() {
    this.fetch();
    this.defaultBatchNo = this.getDefaultBatchNo();
  },
  methods: {
    getDefaultBatchNo() {
      const cc = sessionStorage.getItem('batchId');
      const ids = localStorage.getItem('searchCaseIds');
      if (ids) {
        return [];
      }
      const SelectRobotCaseListReq = JSON.parse(sessionStorage.getItem('SelectRobotCaseListReq'));
      if (sessionStorage.getItem('batchId')) {
        console.warn(Number(cc));
        return [Number(cc)];
      } else if (SelectRobotCaseListReq.batchNo) {
        return SelectRobotCaseListReq.batchNo.split(',').map(item => Number(item));
      }
      console.warn('computed');
      return [Number(cc)];
    },
    fetch() {
      this.getList();
      this.getCaseStatus();
      this.getLoanInstitution();
      this.getselfStatus();
      this.contactStatus();
      this.getStrategyList();
      this.getTemplateList('msg');
      // this.getBatchNo();
      this.getLabelName();
      this.getSendChannel('msg');
    },
    deploy(dp) {
      this.ruleSearchShow = !dp;
    },
    toDetail(row) {
      window.open(`/main/case/detail/${Base64.encode(row.caseId)}`);
    },
    // 手动发送
    submit() {
      const query = this.getSearch(1);
      const targets = this.cas.target;
      if (targets.length === 0) {
        this.$message.warning('请选择发送对象');
        return;
      }
      for (let i = 0; i < targets.length; i++) {
        if (targets[i] === '本人') {
          query.isSendAllSelf = 'benrendianhua';
        }
        if (targets[i] === '直系') {
          query.isSendAllDirect = 'zhixidianhua';
        }
        if (targets[i] === '非直系') {
          query.isSendAllNoDirect = 'feizhixidianhua';
        }
        if (targets[i] === '失联修复') {
          query.isRepair = 'repair';
        }
      }
      // 发送比例
      query.sendMsgRate = this.cas.sendMsgRate;
      // 发送模版
      query.template = this.cas.sendTemplate;
      // 定时发送
      query.sendTimeWay = this.cas.sendTimeWay;
      query.channel = this.cas.channel;
      query.sendType = this.cas.sendType;
      if (this.cas.sendTimeWay === 'manual_timing') {
        const val = new Date(this.timing);
        const date = new Date();
        if (val < date) {
          this.$message.warning('定时时间不能小于当前时间');
          return;
        }
        query.timing = this.timing;
      }
      this.send = false;
      const loading = this.$partLoading();
      this.$ajax({
        url: '/robotCase/getManualSendMsgInfo',
        params: query
      }).then((res) => {
        loading.close();
        console.warn('手动发送');
        if (res.data.batchNum >= 5) {
          this.$message.warning('很抱歉，您无法同时对五个批次以上进行批量发送');
          return;
        }
        if (res.data.channelIsExist !== 1) {
          this.$message.warning('很抱歉，您选择的发送通道并未开启！');
          return;
        }
        if (res.data.total >= 500 || res.data.paidNum !== 0) {
          this.openSend(res.data, query);
          return;
        }
        this.confirmSend(query);
      });
    },
    openSend(data, query) {
      console.warn('发送');
      this.$confirm(`发送联系人包含${data.total}位联系人,${data.paidNum}位联系人属于${data.paidCaseNum}件已核实还款案件?`, '确认是否发送', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.confirmSend(query);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消发送'
        });
      });
    },
    confirmSend(query) {
      const loading = this.$partLoading();
      this.$ajax({
        url: '/robotCase/manualSendMsg',
        params: query
      }).then(() => {
        loading.close();
        this.send = false;
        this.searchBtn(1, false);
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '发送失败!'
        });
      });
    },
    getChangeType() {
      this.getTemplateList(this.cas.sendType);
      this.getSendChannel(this.cas.sendType);
    },
    getValue() {
      // this.$message.warning(`${this.cas.sendTimeWay}`);
    },
    exportAll(command) {
      // this.$message.warning(`${command}`);
      // 导出至邮箱
      if (command === 'exportMail') {
        const queryData = this.getSearchMap();
        this.$ajax({
          url: '/robotCase/exportCaseList',
          params: queryData
        }).then((res) => {
          console.warn(res.msg);
        }).catch((error) => {
          this.$message({
            type: 'error',
            message: error.message
          });
        });
      }
      // 导出至Excel
      if (command === 'exportExcel') {
        const queryData = this.getSearchMap();
        // const newWindow = window.open('_blank');
        this.$ajax({
          url: '/robotCase/checkImmediateExportCaseList',
          params: queryData
        }).then(() => {
          queryData.excelToken = localStorage.getItem('authorization');
          const fileUrl = '/webapi/v1/robotCase/exportCaseListToExcel';
          const form = document.createElement('form');
          form.setAttribute('action', fileUrl);
          form.setAttribute('method', 'get');
          form.setAttribute('id', 'download');
          document.body.appendChild(form);
          Object.keys(queryData).forEach((key) => {
            const input = document.createElement('input');
            input.setAttribute('name', key);
            input.setAttribute('value', queryData[key]);
            input.style.display = 'none';
            form.appendChild(input);
          });
          form.submit();
          setTimeout(() => {
            const parent = document.querySelector('#download');
            const childs = parent.childNodes;
            for (let i = childs.length - 1; i >= 0; i--) {
              parent.removeChild(childs[i]);
            }
            document.body.removeChild(form);
          }, 1000);
        }).catch((error) => {
          this.$message({
            type: 'error',
            message: error.message
          });
        });
      }
      // 导出至日蚀
      if (command === 'exportProperty') {
        this.$ajax({
          url: '/exportCase/checkUser',
          method: 'get'
        }).then((res) => {
          if (res.data === 'jump') {
            this.$confirm('您尚未绑定资易通账号，是否前往公司信息立即绑定？', '导出至资易通系统', {
              confirmButtonText: '跳转至公司信息',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push({ path: '/main/company/robotCompanyManage' });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '取消发送'
              });
            });
          } else {
            this.zytServerToken = res.data;
            this.exportCaseToProperty();
          }
        });
      }
    },
    // 展示案件导出数量
    exportCaseToProperty() {
      const queryData = this.getSearch(1);
      this.$ajax({
        url: '/exportCase/getCaseListCount',
        params: queryData
      }).then((res) => {
        this.count = res.data;
        this.exportCaseToPropertyModel = true;
      });
    },
    // 导出至日蚀系统提交
    exportCaseToZYT() {
      const queryData = this.getSearch(1);
      const zyt = this.zyt;
      queryData.commissionRateA = zyt.commissionRateA;
      queryData.platformRate = zyt.platformRate;
      queryData.startTime = zyt.exportStartTime;
      queryData.endTime = zyt.exportEndTime;
      queryData.exportNewBatch = zyt.exportNewBatch;
      queryData.zytServerToken = this.zytServerToken;
      if (new Date(zyt.exportStartTime).getTime() >= new Date(zyt.exportEndTime).getTime()) {
        this.$message({
          type: 'error',
          message: '起委时间不能大于或等于结委时间'
        });
        return;
      }
      this.$ajax({
        // prompt: true,
        url: '/exportCase/getExportCaseList',
        params: queryData
      }).then((res) => {
        const err = JSON.parse(res.data);
        if (err.success) {
          this.exportCaseToPropertyModel = false;
          this.$message({
            type: 'success',
            message: err.msg
          });
        } else {
          this.$message({
            type: 'error',
            message: err.msg
          });
        }
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    voiceCallResult(command) {
      // 更新案件状态
      if (command === 'caseStatus') {
        this.caseStatus = true;
      }
      // 更新作业方案
      if (command === 'collectionScheme') {
        this.collectionScheme = true;
      }
      // 暂停作业
      if (command === 'pauseUrge') {
        this.updateUrgeStatus(-1);
      }
      // 继续作业
      if (command === 'continueUrge') {
        this.updateUrgeStatus(1);
      }
      // 更新策略组
      if (command === 'openStrategyGroupModal') {
        this.openStrategyGroupModal();
      }
      // 更新本人标签
      if (command === 'openLableModal') {
        this.openLableModal();
      }
    },
    importUpdate(command) {
      // 更新还款及金额
      if (command === 'importForm') {
        this.importForm = true;
      }
      // 添加联系人
      if (command === 'importContactForm') {
        this.importContactForm = true;
      }
    },
    getFile(event) {
      this.file = event.target.files[0];
    },
    // 更新还款及金额
    importUpdateUploadData(event) {
      event.preventDefault();
      const formData = new FormData();
      if (this.file === '') {
        this.$message.warning('请选择要上传的文件！');
        return;
      }
      formData.append('file', this.file);
      this.$ajax({
        prompt: true,
        url: '/robotCaseImport/importCaseToUpdate',
        data: formData
      }).then(() => {
        this.importForm = false;
      });
    },
    handleRemove(file, fileList) {
      console.warn(file, fileList);
    },
    handlePreview(file) {
      console.warn(file);
    },
    handleExceed(files, fileList) {
      console.warn(fileList);
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length} 个文件`);
    },
    beforeRemove() {
      this.fileList = [];
    },
    fileChanged(files, fileList) {
      if (files.size > (5 * 1024 * 1024)) {
        this.$message.warning('文件大小超出5M,请重新选择！');
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
    },
    // 添加联系人
    addContactInfo() {
      if (this.fileList.length === 0) {
        this.$message({
          type: 'error',
          message: '上传文件不能为空!'
        });
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      this.$ajax({
        prompt: true,
        url: '/robotCaseImport/importContactToAdd',
        contentType: 'multipart/form-data',
        data: formData
      }).then(() => {
        this.importContactForm = false;
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 案件状态选择框
    getCaseStatus() {
      const self = this;
      this.$ajax({
        url: '/robotCase/getCaseStatus'
      }).then((res) => {
        self.statusList = res.data;
        self.updateStatusList = res.data;
      });
    },
    // 贷款机构选择框
    getLoanInstitution() {
      const self = this;
      this.$ajax({
        method: 'GET',
        url: '/robotCase/getLoanInstitutionsList'
      }).then((res) => {
        self.loanInstitutionList = res.data;
      });
    },
    // 本人状态选择框
    getselfStatus() {
      const self = this;
      this.$ajax({
        url: '/robotCase/getContactStatus',
        params: { 'modelType': 'benrendianhuaContactStatus' }
      }).then((res) => {
        self.selfStatusList = res.data;
      });
    },
    // 联系人状态选择框
    contactStatus() {
      const self = this;
      this.$ajax({
        url: '/robotCase/getContactStatus',
        params: { 'modelType': 'zhixidianhuaContactStatus' }
      }).then((res) => {
        self.contactStatusList = res.data;
      });
    },
    // 策略组下拉框
    getStrategyList() {
      const self = this;
      this.$ajax({
        url: '/robotCase/getStrategyList',
        method: 'get'
      }).then((res) => {
        self.strategyList = res.data;
      });
    },
    // 批次号下拉框
    // getBatchNo() {
    //   this.$ajax({
    //     url: '/robotCase/getBatchDataList'
    //   }).then((res) => {
    //     this.batchNoList = res.data;
    //   });
    // },
    // 批次号搜索
    searchBatchList(val) {
      this.$ajax({
        url: '/robotCase/searchBatchDataList',
        params: { 'val': val }
      }).then((res) => {
        this.batchNoList = res.data;
      });
    },
    // 标签列表
    getLabelName() {
      const self = this;
      this.$ajax({
        url: '/label/getLable',
        method: 'get'
      }).then((res) => {
        self.labelNameList = res.data;
      });
    },
    // 重置
    resetBtn() {
      console.warn('重置按钮');
      this.cas.status = [];
      this.cas.loanInstitution = [];
      this.cas.selfStatus = [];
      this.cas.contactStatus = [];
      this.cas.importStartTime = '';
      this.cas.importEndTime = '';
      this.cas.batchNo = [];
      this.cas.strategy = [];
      this.cas.lastAnswerTime = '';
      this.cas.lastAnswerTimeEnd = '';
      this.cas.replyTimes = [];
      this.cas.labelName = [];
      this.cas.collectionEndDay = '';
      this.cas.collectionEndDayEnd = '';
      this.isSelected = false;
      this.defaultBatchNo = [];
    },
    // 获取页面展示数据
    getList() {
      console.warn('搜索数据');
      this.loading = true;
      let SelectRobotCaseListReq = {};
      // 判断是否顶部栏搜索得到结果
      let ids = localStorage.getItem('searchCaseIds');
      if (ids) {
        ids = JSON.parse(ids);
        this.cas.ids = ids;
        SelectRobotCaseListReq = this.getSearch(1);
      } else {
        const batchId = sessionStorage.getItem('batchId');
        const caseStatusCode = sessionStorage.getItem('caseStatusCode');
        // 判断是否是案件导入进入页面
        if (batchId !== '' && batchId !== null) {
          SelectRobotCaseListReq = this.getSearch(1);
          SelectRobotCaseListReq.batchNo = batchId;
          this.cas.batchNo = [Number(batchId)];
          // 批次号缓存置空
          sessionStorage.setItem('batchId', '');
          // 写入缓存
          sessionStorage.setItem('SelectRobotCaseListReq', JSON.stringify(SelectRobotCaseListReq));
        } else if (caseStatusCode !== '' && caseStatusCode !== null) { // 判断是否是总览进入页面
          SelectRobotCaseListReq = this.getSearch(1);
          SelectRobotCaseListReq.caseStatus = caseStatusCode;
          this.cas.status = [caseStatusCode];
          // 案件状态缓存置空
          sessionStorage.setItem('caseStatusCode', '');
          // 写入缓存
          sessionStorage.setItem('SelectRobotCaseListReq', JSON.stringify(SelectRobotCaseListReq));
        } else {
          console.warn('读取缓存数据');
          SelectRobotCaseListReq = JSON.parse(sessionStorage.getItem('SelectRobotCaseListReq'));
          if (SelectRobotCaseListReq !== null) {
            if (SelectRobotCaseListReq.batchNo) {
              const aa = SelectRobotCaseListReq.batchNo.split(',');
              const bb = [];
              aa.forEach((a) => {
                bb.push(Number(a));
              });
              this.cas.batchNo = bb;
            }
            if (SelectRobotCaseListReq.caseStatus) {
              this.cas.status = SelectRobotCaseListReq.caseStatus.split(',');
            }
            if (SelectRobotCaseListReq.loanInstitution) {
              this.cas.loanInstitution = SelectRobotCaseListReq.loanInstitution.split(',');
            }
            if (SelectRobotCaseListReq.selfStatus) {
              this.cas.selfStatus = SelectRobotCaseListReq.selfStatus.split(',');
            }
            if (SelectRobotCaseListReq.contactStatus) {
              this.cas.contactStatus = SelectRobotCaseListReq.contactStatus.split(',');
            }
            if (SelectRobotCaseListReq.importStartTime) {
              this.cas.importStartTime = SelectRobotCaseListReq.importStartTime;
            }
            if (SelectRobotCaseListReq.importEndTime) {
              this.cas.importEndTime = SelectRobotCaseListReq.importEndTime;
            }
            if (SelectRobotCaseListReq.strategy) {
              const aa = SelectRobotCaseListReq.strategy.split(',');
              const bb = [];
              aa.forEach((a) => {
                bb.push(Number(a));
              });
              this.cas.strategy = bb;
            }
            if (SelectRobotCaseListReq.lastAnswerTime) {
              this.cas.lastAnswerTime = SelectRobotCaseListReq.lastAnswerTime;
            }
            if (SelectRobotCaseListReq.lastAnswerTimeEnd) {
              this.cas.lastAnswerTimeEnd = SelectRobotCaseListReq.lastAnswerTimeEnd;
            }
            if (SelectRobotCaseListReq.replyTimes) {
              this.cas.replyTimes = SelectRobotCaseListReq.replyTimes.split(',');
            }
            if (SelectRobotCaseListReq.labelName) {
              this.cas.labelName = SelectRobotCaseListReq.labelName.split(',');
            }
            if (SelectRobotCaseListReq.collectionEndDay) {
              this.cas.collectionEndDay = SelectRobotCaseListReq.collectionEndDay;
            }
            if (SelectRobotCaseListReq.collectionEndDayEnd) {
              this.cas.collectionEndDayEnd = SelectRobotCaseListReq.collectionEndDayEnd;
            }
            if (SelectRobotCaseListReq.isSelected) {
              this.isSelected = SelectRobotCaseListReq.isSelected;
            }
            this.difficultyScore = SelectRobotCaseListReq.difficultyScore.split(',');
          } else {
            SelectRobotCaseListReq = this.getSearch(1);
          }
        }
      }
      this.$ajax({
        url: '/robotCase/getCaseList',
        data: SelectRobotCaseListReq
      }).then((res) => {
        this.list = res.data.list;
        // 赋值总条数
        this.recordsFiltered = res.data.totalRecords;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    // 搜索
    searchBtn(val, clear) {
      // 清除顶部栏搜索结果
      if (clear) {
        localStorage.removeItem('searchCaseIds');
        this.cas.ids = [];
      }
      this.loading = true;
      this.list = [];
      const query = this.getSearch(val);
      // this.setStorage(this.$route.query.batchId, query);
      this.$ajax({
        url: '/robotCase/getCaseList',
        data: query
      }).then((res) => {
        this.list = res.data.list;
        // 赋值总条数
        this.recordsFiltered = res.data.totalRecords;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    // 获取搜索选项对象
    getSearch(val) {
      const query = {
        limit: this.pageSize,
        order: 'lastAnswerTime',
        page: val,
        sort: 'desc',
        caseStatus: this.cas.status.join(','),
        loanInstitution: this.cas.loanInstitution.join(','),
        selfStatus: this.cas.selfStatus.join(','),
        contactStatus: this.cas.contactStatus.join(','),
        importStartTime: this.cas.importStartTime,
        importEndTime: this.cas.importEndTime,
        batchNo: this.cas.batchNo.join(','),
        strategy: this.cas.strategy.join(','),
        lastAnswerTime: this.cas.lastAnswerTime,
        lastAnswerTimeEnd: this.cas.lastAnswerTimeEnd,
        replyTimes: this.cas.replyTimes.join(','),
        labelName: this.cas.labelName.join(','),
        collectionEndDay: this.cas.collectionEndDay,
        collectionEndDayEnd: this.cas.collectionEndDayEnd,
        difficultyScore: this.difficultyScore.join(','),
        isSelected: this.isSelected,
        ids: this.cas.ids.join(',')
      };
      // 搜索条件写进缓存
      sessionStorage.setItem('SelectRobotCaseListReq', JSON.stringify(query));
      return query;
    },
    getSearchMap() {
      const queryData = {};
      if (this.cas.status.join(',')) {
        queryData.caseStatus = this.cas.status.join(',');
      }
      if (this.cas.loanInstitution.join(',')) {
        queryData.loanInstitution = this.cas.loanInstitution.join(',');
      }
      if (this.cas.selfStatus.join(',')) {
        queryData.selfStatus = this.cas.selfStatus.join(',');
      }
      if (this.cas.contactStatus.join(',')) {
        queryData.contactStatus = this.cas.contactStatus.join(',');
      }
      if (this.cas.importStartTime) {
        queryData.importStartTime = this.cas.importStartTime;
      }
      if (this.cas.importEndTime) {
        queryData.importEndTime = this.cas.importEndTime;
      }
      if (this.cas.batchNo.join(',')) {
        queryData.batchNo = this.cas.batchNo.join(',');
      }
      if (this.cas.strategy.join(',')) {
        queryData.strategy = this.cas.strategy.join(',');
      }
      if (this.cas.lastAnswerTime) {
        queryData.lastAnswerTime = this.cas.lastAnswerTime;
      }
      if (this.cas.lastAnswerTimeEnd) {
        queryData.lastAnswerTimeEnd = this.cas.lastAnswerTimeEnd;
      }
      if (this.cas.replyTimes.join(',')) {
        queryData.replyTimes = this.cas.replyTimes.join(',');
      }
      if (this.cas.labelName.join(',')) {
        queryData.labelName = this.cas.labelName.join(',');
      }
      if (this.cas.collectionEndDay) {
        queryData.collectionEndDay = this.cas.collectionEndDay;
      }
      if (this.cas.collectionEndDayEnd) {
        queryData.collectionEndDayEnd = this.cas.collectionEndDayEnd;
      }
      if (this.isSelected) {
        queryData.difficultyScore = this.difficultyScore.join(',');
      }
      if (this.cas.ids) {
        queryData.ids = this.cas.ids.join(',');
      }
      return queryData;
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchBtn(1, false);
    },
    // 页码
    handleCurrentChange(val) {
      this.searchBtn(val, false);
    },
    // 发送模版下拉框
    getTemplateList(type) {
      this.$ajax({
        url: '/robotCase/getTemplateByCompanyId',
        data: { 'type': type }
      }).then((res) => {
        this.cas.sendTemplate = `${res.data[0].content}&&${res.data[0].id}&&${res.data[0].type}`;
        this.templateList = res.data;
      });
    },
    number() {
      this.cas.sendMsgRate = this.cas.sendMsgRate.replace(/\D/g, '');
      if (this.cas.sendMsgRate > 100) {
        this.cas.sendMsgRate = 100;
      }
      if (this.cas.sendMsgRate <= 0) {
        this.cas.sendMsgRate = 1;
      }
    },
    setStorage(id, query) {
      let storage = localStorage.getItem('caseList');
      storage = storage ? JSON.parse(storage) : {};
      storage[id] = query;
      localStorage.setItem('caseList', JSON.stringify(storage));
    },
    getStorage(id) {
      let query = localStorage.getItem('caseList');
      if (!query) {
        return {};
      }
      query = JSON.parse(query);
      return query[id] || {};
    },
    // 批量更新案件状态
    updateCaseStatus() {
      this.caseStatus = false;
      const loading = this.$partLoading();
      const queryData = this.getSearchMap();
      queryData.updateCaseStatus = this.cas.updateStatus;
      this.$ajax({
        url: '/robotCase/updateCaseStatus',
        params: queryData
      }).then(() => {
        loading.close();
        this.searchBtn(1, false);
      }).catch((error) => {
        loading.close();
        this.caseStatus = true;
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 批量更新作业方案
    updateCollPlan() {
      const queryData = this.getSearchMap();
      queryData.type = this.cas.collectionSetting;
      queryData.days = this.cas.days;
      queryData.discount = this.cas.maxMitigate;
      const collectionObjects = this.cas.CollectionObjects;
      if (collectionObjects.length === 0) {
        this.$message.warning('请选择发送对象');
        return;
      }
      queryData.isSendAllSelf = '0';
      queryData.isSendAllDirect = '0';
      queryData.isSendAllNoDirect = '0';
      queryData.isRepair = '0';
      for (let i = 0; i < collectionObjects.length; i++) {
        if (collectionObjects[i] === 'benrendianhua') {
          queryData.isSendAllSelf = '1';
        }
        if (collectionObjects[i] === 'zhixidianhua') {
          queryData.isSendAllDirect = '1';
        }
        if (collectionObjects[i] === 'feizhixidianhua') {
          queryData.isSendAllNoDirect = '1';
        }
        if (collectionObjects[i] === 'repair') {
          queryData.isRepair = '1';
        }
      }
      const loading = this.$partLoading();
      this.collectionScheme = false;
      this.$ajax({
        url: '/robotCase/updatePlan',
        params: queryData
      }).then(() => {
        loading.close();
        this.searchBtn(1, false);
      }).catch((error) => {
        this.collectionScheme = true;
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 暂停 继续 作业
    updateUrgeStatus(status) {
      const loading = this.$partLoading();
      const queryData = this.getSearchMap();
      queryData.VERIFY = 'VERIFY';
      queryData.urgeStatus = status;
      this.$ajax({
        url: '/robotCase/updateUrgeStatus',
        params: queryData
      }).then((res) => {
        loading.close();
        if (status === -1) {
          this.t = '暂停作业';
        } else {
          this.t = '继续作业';
        }
        this.$confirm('', `${this.t}案件数：${res.data}件`, {
          confirmButtonText: `${this.t}`,
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loadings = this.$partLoading();
          const queryDatas = this.getSearchMap();
          queryDatas.urgeStatus = status;
          this.$ajax({
            url: '/robotCase/updateUrgeStatus',
            params: queryDatas
          }).then(() => {
            loadings.close();
            this.t = '';
          }).catch((error) => {
            loadings.close();
            this.$message({
              type: 'error',
              message: error.message
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: `取消${this.t}`
          });
          this.t = '';
        });
      });
    },
    // 批量更新策略组
    openStrategyGroupModal() {
      const queryData = this.getSearchMap();
      if (Object.keys(queryData).length === 0) {
        this.$message.warning('请选择筛选条件');
        return;
      }
      this.$ajax({
        url: '/robotCase/getStrategyList',
        params: queryData
      }).then((res) => {
        this.strategyGroup = res.data;
        this.cas.group = res.data[0].id;
        this.caseGrouds = true;
      });
    },
    // 批量更新策略组提交
    updateStrategyGroup() {
      const queryData = this.getSearchMap();
      queryData.updateStrategyGroup = this.cas.group;
      queryData.isReset = this.cas.isReset;
      this.caseGrouds = false;
      const loading = this.$partLoading();
      this.$ajax({
        url: '/robotCase/updateStrategyGroup',
        params: queryData
      }).then(() => {
        loading.close();
        this.searchBtn(1, false);
      }).catch((error) => {
        this.caseGrouds = true;
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 批量更新本人标签
    openLableModal() {
      this.$ajax({
        url: '/label/getLables',
        method: 'get'
      }).then((res) => {
        this.updateLabelNameList = res.data;
        this.cas.updateLabelName = res.data[0].name;
        this.caseLabel = true;
      });
    },
    updateLable() {
      const queryData = this.getSearchMap();
      if (Object.keys(queryData).length === 0) {
        this.$message.warning('请选择筛选条件');
        return;
      }
      queryData.updateLabelName = this.cas.updateLabelName;
      const loading = this.$partLoading();
      this.caseLabel = false;
      this.$ajax({
        url: '/robotCase/updateLable',
        params: queryData
      }).then(() => {
        loading.close();
        this.searchBtn(1, false);
      }).catch((error) => {
        this.caseLabel = true;
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    // 发送模版下拉框
    getSendChannel(type) {
      this.$ajax({
        url: '/externalServicesConf/getSendChannel',
        params: { 'sendType': type }
      }).then((res) => {
        this.channelList = res.data;
        this.cas.channel = 'all';
      });
    }
  },
  components: {
    // BatchnoSelect,
    // LabelnameSelect
    BatchSelector
  }
};
</script>
<style lang="less" scoped>
.rate-component {
  span {
    display: inline-block;
    width: 20px;
    vertical-align: middle;
  }
  & > div {
    display: inline-block;
    width: 160px;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main/case/list.vue